// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__Q2-Bs","header":"Messages_header__2x-Mf"};